'use client';

import { __resetStyles, __styles, mergeClasses } from "@griffel/react";
import { tokens } from "@fluentui/react-theme";
export const toastClassNames = {
  root: 'fui-Toast'
};
const useRootBaseClassName = /*#__PURE__*/__resetStyles("rhf7k35", null, [".rhf7k35{display:grid;grid-template-columns:auto 1fr auto;padding:12px;border-radius:var(--borderRadiusMedium);border:1px solid var(--colorTransparentStroke);box-shadow:var(--shadow8);font-size:var(--fontSizeBase300);line-height:20px;font-weight:var(--fontWeightSemibold);color:var(--colorNeutralForeground1);background-color:var(--colorNeutralBackground1);}"]);
const useStyles = /*#__PURE__*/__styles({
  inverted: {
    sj55zd: "f1w7i9ko",
    De3pzq: "f5pduvr"
  }
}, {
  d: [".f1w7i9ko{color:var(--colorNeutralForegroundInverted2);}", ".f5pduvr{background-color:var(--colorNeutralBackgroundInverted);}"]
});
/**
 * Apply styling to the Toast slots based on the state
 */
export const useToastStyles_unstable = state => {
  const rootBaseClassName = useRootBaseClassName();
  const styles = useStyles();
  // eslint-disable-next-line react-hooks/immutability
  state.root.className = mergeClasses(toastClassNames.root, rootBaseClassName, state.backgroundAppearance === 'inverted' && styles.inverted, state.root.className);
  return state;
};